import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function FaqAccordion({ faqs, testIdPrefix = "faq" }) {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <div className="divide-y divide-ink/10 border-y border-ink/10" data-testid={`${testIdPrefix}-accordion`}>
      {faqs.map((f, i) => {
        const isOpen = openIdx === i;
        return (
          <div key={i}>
            <button
              onClick={() => setOpenIdx(isOpen ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 py-5 text-left"
              aria-expanded={isOpen}
              data-testid={`${testIdPrefix}-question-${i}`}
            >
              <span className={`text-base font-semibold transition-colors md:text-lg ${isOpen ? "text-forest" : "text-ink"}`}>
                {f.q}
              </span>
              <motion.span
                animate={{ rotate: isOpen ? 45 : 0 }}
                transition={{ duration: 0.25 }}
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${
                  isOpen ? "border-forest bg-forest text-paper" : "border-ink/20 text-ink/60"
                }`}
              >
                <Plus size={15} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="max-w-2xl pb-6 text-sm leading-relaxed text-ink/65 md:text-base" data-testid={`${testIdPrefix}-answer-${i}`}>
                    {f.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
